import React, { FC } from 'react';
import Section from '../../../Components/Section/Section';
import Container from '../../../../../Common/Container/Container';
import Heading from '../../../Components/Heading/Heading';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import IntroText from '../../../Components/IntoText/IntroText';
import DottedList from '../../../../../Common/DottedList/DottedList';
import * as classes from './IntroductionSection.module.scss';
import cn from 'classnames';
import { ServiceIntroductionSectionProps } from '../../../../../Sections/Services/IntroductionSection/IntroductionSection';
import DefaultButton from '../../../Components/DefaultButton/DefaultButton';

const IntroductionSection: FC<ServiceIntroductionSectionProps> = ({ serviceName, specialties, benefits, targetAudience, introText, serviceId }) => {
  const { t } = useTranslation();

  const button = (
    <DefaultButton
      link={{
        title: t('homePage.servicesSection.informationRequestButton.linkTitle'),
        path: t('homePage.servicesSection.informationRequestButton.buttonLink'),
      }}
    >
      {t('homePage.servicesSection.informationRequestButton.buttonText')}
    </DefaultButton>
  );

  return (
    <Section number={'01'} label={t('services.intoSection.sectionTitle')}>
      <Container className={classes.wrapper}>
        <div className='row'>
          <div className='col-xl-5 col-lg-3 col-md-6 col-sm-12 order-1 order-md-0'>
            {!!specialties.length && (
              <div className={classes.listWrapper}>
                <Heading>{serviceName} | {t('services.intoSection.specialties')}</Heading>
                <DottedList items={specialties} />
              </div>
            )}
            {!!benefits?.length && (
              <div className={classes.listWrapper}>
                <Heading>{serviceName} | {t('services.intoSection.canHelpYouWith')}</Heading>
                <DottedList items={benefits} />
              </div>
            )}
            {!!targetAudience.length && (
              <div className={classes.listWrapper}>
                <Heading>{serviceName} {t('services.intoSection.servicesAreProvidedTo')}</Heading>
                <DottedList items={targetAudience} />
              </div>
            )}
            <div className={cn(classes.buttonWrapper, 'd-md-none')}>{button}</div>
          </div>
          <div className='col-xl-7 offset-xl-0 col-lg-7 offset-lg-2 col-md-6 col-sm-12 order-0 order-md-1'>
            <div className={classes.introWrapper}>
              <IntroText key={serviceId} introText={introText} />
            </div>
            <div className={cn(classes.buttonWrapper, 'd-md-flex d-none')}>{button}</div>
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default IntroductionSection;
